import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 4l18 0","key":"svg-0"}],["path",{"d":"M4 4v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-10","key":"svg-1"}],["path",{"d":"M12 16l0 4","key":"svg-2"}],["path",{"d":"M9 20l6 0","key":"svg-3"}],["path",{"d":"M8 12l3 -3l2 2l3 -3","key":"svg-4"}]]

const IconPresentation = createReactComponent('outline', 'presentation', 'Presentation', __iconNode);

export default IconPresentation;